<template>
    <div>
        <div class="display-f just-b align-i-c">
            <div style="width: 90%;" class="display-f align-i-c">
                <el-date-picker class="mr12" style="width: 150px;" type="month" placeholder="开始日期" format="yyyy-MM"
                    value-format="yyyy-MM" v-model="searchMonth" :picker-options="pickerOptions"
                    @change="getClearAccount"></el-date-picker>
                <el-button class="mr12" type="primary" icon="el-icon-search" @click="getClearAccount">查询</el-button>
                <div class="size12 color1F2 border2 back0E1 lh16" style="padding: 6px 12px; ">
                    {{ nowMonth }}月的清算将于{{ nextMonth }}月1号后开始</div>
            </div>
            <el-button type="primary" @click="onekeyClear" :disabled="oneKeyDisabled">一键清算</el-button>
        </div>
        <div v-loading="loading">
            <div class="mt16 w100_ border2 backE8F display-f just-b borderBox" style="padding: 16px 24px;">
                <div class="display-f">
                    <div>
                        <div class="size14 color3F4">医疗费用总额</div>
                        <div class="size20 color189 mt10">{{ clearAccountCensus.medfeeSumamt }}</div>
                    </div>
                    <div class="mr24 ml24">
                        <div class="size14 color3F4" style="height: 14px;"></div>
                        <div class="size20 color189 mt10">=</div>
                    </div>
                    <div>
                        <div class="size14 color3F4">已清算</div>
                        <div class="size20 color189 mt10">{{ clearAccountCensus.clearedMoney }}</div>
                    </div>
                    <div class="mr24 ml24">
                        <div class="size14 color3F4" style="height: 14px;"></div>
                        <div class="size20 color189 mt10">+</div>
                    </div>
                    <div>
                        <div class="size14 color3F4">待清算</div>
                        <div class="size20 color189 mt10">{{ clearAccountCensus.waitClearMoney }}</div>
                    </div>
                    <div class="mr24 ml24">
                        <div class="size14 color3F4" style="height: 14px;"></div>
                        <div class="size20 color189 mt10">+</div>
                    </div>
                    <div>
                        <div class="size14 color3F4">待对账</div>
                        <div class="size20 color189 mt10">{{ clearAccountCensus.waitCheckMoney }}</div>
                    </div>
                </div>
                <div style="text-align: right;">
                    <div class="size14 color3F4">医保认可金额</div>
                    <div class="size20 color30C mt10">{{ clearAccountCensus.acceptMoney }}</div>
                </div>
            </div>
            <custom-table class="mt16" :column="clearTable" :tableData="clearAccountList" :showPages="false">
                <template slot="clrType" slot-scope="{row}">
                    <div v-if="clrTypeList.length > 0 && row.provinceFlag != '1'">{{ computedName(clrTypeList, row.clrType)
                    }}
                    </div>
                    <div v-if="(row.clrType == '11' && row.provinceFlag == '1')">
                        省本级门诊清算
                    </div>
                </template>
                <template slot="clearStatus" slot-scope="{row}">
                    <div style="display: flex;">
                        <div :class="row.clearStatus == 0 ? 'parTag' : 'infoTag'">{{
                            row.clearStatus == 0 ? '待清算' : '已清算'
                        }}</div>
                    </div>
                </template>
                <template slot="handle" slot-scope="{row}">
                    <el-button type="text" @click="doClear(row)" :disabled="row.clearFlag != 1">清算</el-button>
                    <!-- <el-button type="text" v-if="row.clearStatus == 1">打印</el-button> -->
                    <el-button type="text" v-if="row.clearStatus == 1" @click="previewPrint(row)">打印</el-button>
                </template>
            </custom-table>
        </div>
        <CustomDialog :visible.sync="clearDialog" v-if="clearDialog" title="清算申请单" submitText="打印" dialogWidth="700px"
            @submit="choosePrinter" @cancel="clearDialog = false">
            <CustomTemplate :detailInfo="previewInfo"></CustomTemplate>
        </CustomDialog>
        <!-- 清算中提示 -->
        <custom-dialog :visible.sync="hintDialog" title="提示" :showFooter="false" dialogWidth="398px">
            <div>正在清算中，请耐心等待</div>
        </custom-dialog>
        <!-- 打印 -->
        <printDialog v-show="printDialogShow" :printDialogShow="printDialogShow" @printSuccess="printSuccess"
            @closePrintPrescription="closePrintPrescription" :id="printOrderId" :orderType="printOrderType" ref="printDia"
            :printType="printType" @setPrintDiaShow="setPrintDiaShow"></printDialog>
    </div>
</template>
<script>

import { getClearAccountListApi, clearAccountApi, updateClearApi, diffClearSettlementApi } from '@/api/medInsuranceAccount.js';
import CustomTable from '@/components/customTable/customTable.vue';
import CustomDialog from '@/components/customDialog/index.vue';
import CustomTemplate from './template.vue'
import { MedicalInsurance } from '../medicalInsurance.js';
import printDialog from '@/components/printDialog.vue';
import { CommonDTO } from '@/DTO/index.js'
export default {
    components: {
        CustomTable,
        CustomDialog,
        CustomTemplate,
        printDialog
    },
    data() {
        return {
            searchMonth: null,
            nowMonth: null,
            nextMonth: null,
            clearAccountList: [],
            clearAccountCensus: {},
            clearTable: [
                { prop: 'clrType', label: '清算类别', slotName: 'clrType', align: 'left' },
                { prop: 'settleCount', label: '人次', align: 'left' },
                { prop: 'medfeeSumamt', label: '医疗费用总额', align: 'left' },
                { prop: 'fundPaySumamt', label: '基金支付总额', align: 'left' },
                { prop: 'wltpayAmt', label: '钱包支付总额', align: 'left' },
                { prop: 'acctPay', label: '个人账户支出', align: 'left' },
                { prop: 'psnCashPay', label: '现金支付金额', align: 'left' },
                { prop: 'acceptMoney', label: '医保认可金额', align: 'left' },
                { prop: '', label: '清算结果', slotName: 'clearStatus', align: 'left' },
                { prop: '', label: '操作', slotName: 'handle', align: 'left' },
            ],
            loading: false,
            clrTypeList: [],//清算类别
            deptId: this.$session.get('deptId'), // 当前医馆id
            clearDialog: false,//打印预览
            previewInfo: {},//打印预览信息
            oneKeyIndex: 0,//一键对账
            oneKey: false,//是否一键对账
            hintDialog: false,//清算提示框
            oneKeyDisabled: false,//是否可以一键清算
            printDialogShow: false, // 打印模态框
            printOrderId: '',//打印订单id
            printOrderType: '',//订单类型 0挂号 1中药 2理疗 3隐秘 4划价单
            printType: '4',//打印类型 1小票 2处方 3保险 4清算单,
            clrType: [
                { orderType: '8', code: '11', name: '省内异地' },
                { orderType: '9', code: 'N11', name: '省外异地' },
                { orderType: '10', code: '99915', name: '职工门诊统筹清算' },
                { orderType: '11', code: '12', name: '省本级门诊清算' },
                { orderType: '8', code: '99939', name: '城乡门诊统筹清算' },
            ],
            sysTime: null,
        }
    },
    async created() {
        this.init()
    },
    computed: {
        computedName() {
            return function (list, code) {
                return list.filter(val => val.code == code).length > 0 ? list.filter(val => val.code == code)[0].name : code
            }
        },
        computedClrType() {
            let that = this
            return function (code) {
                return that.clrType.filter(val => val.code == code).length > 0 ? that.clrType.filter(val => val.code == code)[0].orderType : code
            }
        },
        pickerOptions() {
            let that = this
            return {
                disabledDate(time) {
                    return time.getTime() > that.sysTime;
                }
            }
        },
    },
    methods: {
        async init() {
            let time = await this.getSysTime();
            this.sysTime = this.$moment(time).valueOf();
            this.searchMonth = this.$moment(time).subtract(1, 'months').format("YYYY-MM");
            this.nowMonth = this.$moment(time).format("M");
            this.nextMonth = this.$moment(time).add(1, 'months').format("M");
            this.getClearAccount()
            this.getTypeList()
        },
        //获取系统时间
        async getSysTime() {
            let res = await CommonDTO.getSystemTimeDTO()
            return new Date(res)
        },
        startAndEndMonth() {
            let nowMonth = this.$moment(this.searchMonth).format("yyyyMM");
            let monthNow = this.$moment(this.searchMonth).format("yyyy-MM");
            let startMonth = this.$moment(this.searchMonth).startOf('month').format("yyyy-MM-DD");
            let endMonth = this.$moment(this.searchMonth).endOf('month').format("yyyy-MM-DD");
            return {
                setlym: nowMonth,
                begndate: startMonth,
                enddate: endMonth,
                clearmonth: monthNow,
            }
        },
        //获取code列表状态
        async getTypeList() {
            const { clrTypeList, clrOptinsList } = await MedicalInsurance.getTypeList()
            //清算类别
            this.clrTypeList = clrTypeList;

        },
        async getClearAccount() {
            if (!this.searchMonth) {
                this.$message.error('请选择时间')
                return false;
            }
            if (this.$moment(this.searchMonth).format("M") == this.nowMonth) {
                this.$message.error('当月的清算于下个月一号开始')
                this.clearAccountList = [];
                this.clearAccountCensus = {};
                return
            }
            this.loading = true
            let obj = {
                startTime: _.toString(new Date(this.$moment(this.searchMonth).startOf('month')).getTime()),
                deptId: this.deptId
            }
            let res = await getClearAccountListApi(obj)
            if (res.code == 200) {
                this.clearAccountList = res.data.items;
                this.clearAccountCensus = res.data.clearAccountCensus;
                this.oneKeyDisabled = this.clearAccountList.some(val => val.clearFlag != 1)
            }
            this.loading = false;
        },
        //异地清算
        async doDiffClear(row) {
            let data = this.startAndEndMonth()
            let diffObj = {
                clr_optins: row.clrOptins,
                data: {
                    clr_type: row.clrType,//清算类别    字符型	30	Y Y
                    // clr_type:row.clrType=='11'?'S11': row.clrType,//清算类别    字符型	30	Y Y
                    mon_setl_cnt: row.settleCount,//本次参与月结算条数   数值型	16,0		Y
                    medfee_sumamt: row.medfeeSumamt,//医疗费总额 数值型	16,2		Y
                    optins_pay_sumamt: row.acceptMoney,//经办机构支付总额 数值型	16,2		Y 基金支付总额+个人账户支付+钱包支付总额
                    begndate: data.begndate,//开始日期 日期型         Y yyyy-MM-dd
                    enddate: data.enddate//结束日期 日期型         Y yyyy-MM-dd
                }
            }
            let diffRes = await diffClearSettlementApi(diffObj)
            if (diffRes.code == 200) {
                let obj = {
                    clrOptins: row.clrOptins,
                    clrType: row.clrType,
                    provinceFlag: row.provinceFlag,
                    clrAppyEvtId: diffRes.data.result.mon_setl_eid,
                    clearTime: _.toString(new Date(this.$moment(this.searchMonth).startOf('month')).getTime()),
                    deptId: this.deptId,
                }
                let res = await updateClearApi(obj)
                if (res.code == 200) {
                    if (this.oneKey) {
                        this.oneKeyIndex += 1
                        this.onekeyClear()
                    } else {
                        this.oneKeyIndex = 0
                        this.getClearAccount()
                    }
                }
            }
            this.hintDialog = false;
        },
        //清算
        async doClear(row) {
            this.hintDialog = true;
            //省内清算
            if (row.clrType == '99915' || row.clrType == '51' || (row.clrType == '11' && row.provinceFlag == '1') || row.clrOptins=='511302') {
                let data = this.startAndEndMonth()
                let obj = {
                    clr_optins: row.clrOptins,
                    clr_type: row.clrType,//清算类别    字符型	30	Y Y
                    // clr_way: "04",//清算方式    字符型	30	Y
                    setlym: data.setlym,//清算年月 ‘6’ 字符型	6		Y
                    psntime: row.settleCount,//清算人次 数值型	6		Y
                    medfee_sumamt: row.medfeeSumamt,//医疗费总额 数值型	16,2		Y
                    med_sumfee: row.acceptMoney,//医保认可费用总额 数值型	16,2		Y
                    fund_appy_sum: this.$bigNumber(row.fundPaySumamt,'+',row.wltpayAmt),//基金支付总额 + 钱包支付总额 数值型	16,2		Y
                    cash_payamt: row.psnCashPay,//现金支付金额 数值型	16,2		Y
                    acct_pay: row.acctPay,//个人账户支出 数值型	16,2		Y
                    begndate: data.begndate,//开始日期 日期型         Y
                    enddate: data.enddate//结束日期 日期型         Y
                }
                let res = await clearAccountApi(obj)
                if (res.code == 200) {
                    let obj1 = {
                        clrOptins: row.clrOptins,
                        clrType: row.clrType,
                        provinceFlag: row.provinceFlag,
                        clrAppyEvtId: res.data.result.clr_appy_evt_id,
                        clearTime: _.toString(new Date(this.$moment(this.searchMonth).startOf('month')).getTime()),
                        deptId: this.deptId,
                    }
                    let res1 = await updateClearApi(obj1)
                    if (res1.code == 200) {
                        if (this.oneKey) {
                            this.oneKeyIndex += 1
                            this.onekeyClear()
                        } else {
                            this.oneKeyIndex = 0
                            this.getClearAccount()
                        }
                    }
                }
            } else {
                this.doDiffClear(row)
            }

            this.hintDialog = false;

        },
        //打印预览
        previewPrint(row) {
            let data = this.startAndEndMonth()
            this.previewInfo = _.cloneDeep(row);
            this.previewInfo.startDate = data.begndate
            this.previewInfo.endDate = data.enddate
            this.previewInfo.clearDate = data.clearmonth
            this.clearDialog = true;
        },
        //一键清算
        onekeyClear() {
            this.oneKey = true
            let list = _.cloneDeep(this.clearAccountList)
            if (this.oneKeyIndex >= list.length) {
                return;
            }
            if (this.oneKeyIndex == (list.length - 1)) {
                this.oneKey = false
            }
            this.doClear(list[this.oneKeyIndex])
        },
        //选择打印机
        choosePrinter() {
            this.printOrderId = this.previewInfo.clrAppyEvtId;
            let code=this.previewInfo.clrType;
            if(code=='11' && this.previewInfo.provinceFlag=='1'){
                code=12
            }
            this.printOrderType = this.computedClrType(code);
            this.$nextTick(() => {
                this.$refs.printDia.useDefaultPrint()
            })
        },
        setPrintDiaShow() {
            this.printDialogShow = true;
        },
        /**
        * 取消打印
        */
        closePrintPrescription() {
            this.printDialogShow = false
        },
        /**
         * 打印完成
        */
        printSuccess() {
            this.printDialogShow = false;
            this.clearDialog = false;
        },
    }
}
</script>

<style lang="less" scoped>
/deep/ .el-table thead {
    color: #5A6678;
}

/deep/ .el-table th.el-table__cell {
    background-color: #EBEAEE !important;
}

.customTable-wrap {
    border: 1px solid #EBEAEE;
    border-radius: 2px;
}
</style>